export var IMAGE_PRELOAD_BATCH_SIZE = 3;
export var NO_OF_SCREENS_TO_PRELOAD = IMAGE_PRELOAD_BATCH_SIZE;
export var NO_OF_SCREENS_TO_PRELOAD_WHEN_EMBEDDED = 1;
export var PRELOADING_DEPTH = 3;
